export const enum DemoActionType {
  CREATE_DEMO = 'CREATE_DEMO',
  RETRIEVE_DEMO = 'RETRIEVE_DEMO',
  UPDATE_DEMO = 'UPDATE_DEMO',
  DELETE_DEMO = 'DELETE_DEMO',
  DELETE_ALL_DEMO = 'DELETE_ALL_DEMO',
}
